// Step registry: each step type is defined once, so the runner, trail and
// viewers all read the same definition (label, description, input counts).
const registry = new Map();

export const defineStep = (definition) => {
  const { type, label, category, description, run } = definition;
  if (!type || !label || !category || !description || typeof run !== "function") {
    throw new Error(`Step definition "${type}" is missing type, label, category, description or run`);
  }
  return { inputs: { min: 1, max: 1 }, params: {}, ...definition };
};

export const registerSteps = (definitions) => {
  definitions.forEach((definition) => registry.set(definition.type, definition));
};

export const getStepDefinition = (type) => registry.get(type);
